export interface PortalNoMapa {
  readonly id: string;
  readonly x: number;
  readonly y: number;
  readonly destinoMapa: string;
  readonly destX: number;
  readonly destY: number;
  readonly efeito: string;
  readonly rotulo: string;
}

const ID_OK = /^[a-z0-9-]+$/;
const VAZIO: readonly PortalNoMapa[] = [];
const EFEITO_PADRAO = 'gate-travel-opened';

/** Chebyshev do aceite. Espelha `PortalLimits.Alcance` no servidor. */
export const PORTAL_ALCANCE = 2;

export async function carregarPortais(mapaArquivo: string, sinal?: AbortSignal): Promise<readonly PortalNoMapa[]> {
  const stem = mapaArquivo.replace(/\.json$/i, '');
  if (!ID_OK.test(stem)) return VAZIO;
  try {
    const { api } = await import('../api');
    const { etagAtual } = await import('../data/mundoSync');
    const lista = await api.portaisDoMundo(etagAtual() || '1-00000000', stem);
    if (sinal?.aborted) return VAZIO;
    const out: PortalNoMapa[] = [];
    for (const p of lista) {
      if (!p.id || !ID_OK.test(p.id)) continue;
      if (!ID_OK.test(p.destinoMapa)) continue;
      const efeito = p.efeito && ID_OK.test(p.efeito) ? p.efeito : EFEITO_PADRAO;
      out.push({
        id: p.id,
        x: p.x | 0,
        y: p.y | 0,
        destinoMapa: p.destinoMapa,
        destX: p.destX | 0,
        destY: p.destY | 0,
        efeito,
        rotulo: p.rotulo || p.destinoMapa
      });
      if (out.length >= 64) break;
    }
    return out;
  } catch {
    // Portais vêm só do servidor (world_portals; techspec-editor-de-mapa §02.3): sem arquivo de reserva.
    return VAZIO;
  }
}
